import {HomeIcon, PoiBusIcon, PoiEducationIcon, PoiEntertainmentIcon, PoiFoodIcon, PoiHealthIcon, PoiShopIcon, PoiSportIcon} from "@pg-design/icons-module";
import {pluralize} from "@pg-mono/string-utils";

import {POI_COLORS} from "../constants/poi_colors";
import {PoiType, TransportPoiType} from "../types/PoiType";

export const getPoiPluralizeLabel = (type: PoiType, value: number): string => {
    switch (type) {
        case PoiType.EDUCATION:
            return `${value} ${pluralize(["placówka edukacyjna", "placówki edukacyjne", "placówek edukacyjnych"])(value)}`;
        case PoiType.ENTERTAINMENT:
            return `${value} ${pluralize(["plac zabaw", "place zabaw", "placów zabaw"])(value)}`;
        case PoiType.FOOD:
            return `${value} ${pluralize(["kawiarnia lub restauracja", "kawiarnie i restauracje", "kawiarni i restauracji"])(value)}`;
        case PoiType.HEALTH:
            return `${value} ${pluralize(["placówka medyczna", "placówki medyczne", "placówek medycznych"])(value)}`;
        case PoiType.SHOPS:
            return `${value} ${pluralize(["sklep", "sklepy", "sklepów"])(value)}`;
        case PoiType.SPORT:
            return `${value} ${pluralize(["obiekt sportowy", "obiekty sportowe", "obiektów sportowych"])(value)}`;
        default:
            return "";
    }
};

export const PLACES_POI_CONFIG = [
    {type: PoiType.FOOD, label: "Kawiarnie i restauracje", icon: PoiFoodIcon, color: POI_COLORS[PoiType.FOOD]},
    {type: PoiType.SHOPS, label: "Sklepy", icon: PoiShopIcon, color: POI_COLORS[PoiType.SHOPS]},
    {type: PoiType.SPORT, label: "Sport", icon: PoiSportIcon, color: POI_COLORS[PoiType.SPORT]},
    {type: PoiType.HEALTH, label: "Zdrowie", icon: PoiHealthIcon, color: POI_COLORS[PoiType.HEALTH]},
    {type: PoiType.EDUCATION, label: "Edukacja", icon: PoiEducationIcon, color: POI_COLORS[PoiType.EDUCATION]},
    {type: PoiType.ENTERTAINMENT, label: "Place zabaw", icon: PoiEntertainmentIcon, color: POI_COLORS[PoiType.ENTERTAINMENT]}
] as const;

export const SWITCHER_POI_CONFIG = [
    {type: PoiType.OFFERS, label: "Inwestycje", icon: HomeIcon, color: POI_COLORS[PoiType.OFFERS]},
    {type: PoiType.TRANSPORT, label: "Komunikacja", icon: PoiBusIcon, color: POI_COLORS[PoiType.TRANSPORT]},
    {type: PoiType.EDUCATION, label: "Edukacja", icon: PoiEducationIcon, color: POI_COLORS[PoiType.EDUCATION]},
    {type: PoiType.SHOPS, label: "Sklepy", icon: PoiShopIcon, color: POI_COLORS[PoiType.SHOPS]},
    {type: PoiType.SPORT, label: "Sport", icon: PoiSportIcon, color: POI_COLORS[PoiType.SPORT]},
    {type: PoiType.HEALTH, label: "Zdrowie", icon: PoiHealthIcon, color: POI_COLORS[PoiType.HEALTH]},
    {type: PoiType.ENTERTAINMENT, label: "Place zabaw", icon: PoiEntertainmentIcon, color: POI_COLORS[PoiType.ENTERTAINMENT]},
    {type: PoiType.FOOD, label: "Kawiarnie i restauracje", icon: PoiFoodIcon, color: POI_COLORS[PoiType.FOOD]}
] as const;

export const getTransportStopPluralizeLabel = (type: TransportPoiType, count: number): string => {
    switch (type) {
        case TransportPoiType.TRAM:
            return `${count} ${pluralize(["przystanek tramwajowy", "przystanki tramwajowe", "przystanków tramwajowych"])(count)}`;
        case TransportPoiType.BUS:
            return `${count} ${pluralize(["przystanek autobusowy", "przystanki autobusowe", "przystanków autobusowych"])(count)}`;
        case TransportPoiType.SUBWAY:
            return `${count} ${pluralize(["przystanek metra", "przystanki metra", "przystanków metra"])(count)}`;
        case TransportPoiType.RAILWAY:
            return `${count} ${pluralize(["stacja kolejowa", "stacje kolejowe", "stacji kolejowych"])(count)}`;
        default:
            return "";
    }
};

export const getNearestStopLabel = (type: TransportPoiType): string => {
    switch (type) {
        case TransportPoiType.RAILWAY:
            return "najbliższa";
        default:
            return "najbliższy";
    }
};
import {HomeIcon, PoiBusIcon, PoiEducationIcon, PoiEntertainmentIcon, PoiFoodIcon, PoiHealthIcon, PoiShopIcon, PoiSportIcon} from "@pg-design/icons-module";
import {pluralize} from "@pg-mono/string-utils";

import {POI_COLORS} from "../constants/poi_colors";
import {PoiType, TransportPoiType} from "../types/PoiType";

export const getPoiPluralizeLabel = (type: PoiType, value: number): string => {
    switch (type) {
        case PoiType.EDUCATION:
            return `${value} ${pluralize(["placówka edukacyjna", "placówki edukacyjne", "placówek edukacyjnych"])(value)}`;
        case PoiType.ENTERTAINMENT:
            return `${value} ${pluralize(["plac zabaw", "place zabaw", "placów zabaw"])(value)}`;
        case PoiType.FOOD:
            return `${value} ${pluralize(["kawiarnia lub restauracja", "kawiarnie i restauracje", "kawiarni i restauracji"])(value)}`;
        case PoiType.HEALTH:
            return `${value} ${pluralize(["placówka medyczna", "placówki medyczne", "placówek medycznych"])(value)}`;
        case PoiType.SHOPS:
            return `${value} ${pluralize(["sklep", "sklepy", "sklepów"])(value)}`;
        case PoiType.SPORT:
            return `${value} ${pluralize(["obiekt sportowy", "obiekty sportowe", "obiektów sportowych"])(value)}`;
        default:
            return "";
    }
};

export const PLACES_POI_CONFIG = [
    {type: PoiType.FOOD, label: "Kawiarnie i restauracje", icon: PoiFoodIcon, color: POI_COLORS[PoiType.FOOD]},
    {type: PoiType.SHOPS, label: "Sklepy", icon: PoiShopIcon, color: POI_COLORS[PoiType.SHOPS]},
    {type: PoiType.SPORT, label: "Sport", icon: PoiSportIcon, color: POI_COLORS[PoiType.SPORT]},
    {type: PoiType.HEALTH, label: "Zdrowie", icon: PoiHealthIcon, color: POI_COLORS[PoiType.HEALTH]},
    {type: PoiType.EDUCATION, label: "Edukacja", icon: PoiEducationIcon, color: POI_COLORS[PoiType.EDUCATION]},
    {type: PoiType.ENTERTAINMENT, label: "Place zabaw", icon: PoiEntertainmentIcon, color: POI_COLORS[PoiType.ENTERTAINMENT]}
] as const;

export const SWITCHER_POI_CONFIG = [
    {type: PoiType.OFFERS, label: "Inwestycje", icon: HomeIcon, color: POI_COLORS[PoiType.OFFERS]},
    {type: PoiType.TRANSPORT, label: "Komunikacja", icon: PoiBusIcon, color: POI_COLORS[PoiType.TRANSPORT]},
    {type: PoiType.EDUCATION, label: "Edukacja", icon: PoiEducationIcon, color: POI_COLORS[PoiType.EDUCATION]},
    {type: PoiType.SHOPS, label: "Sklepy", icon: PoiShopIcon, color: POI_COLORS[PoiType.SHOPS]},
    {type: PoiType.SPORT, label: "Sport", icon: PoiSportIcon, color: POI_COLORS[PoiType.SPORT]},
    {type: PoiType.HEALTH, label: "Zdrowie", icon: PoiHealthIcon, color: POI_COLORS[PoiType.HEALTH]},
    {type: PoiType.ENTERTAINMENT, label: "Place zabaw", icon: PoiEntertainmentIcon, color: POI_COLORS[PoiType.ENTERTAINMENT]},
    {type: PoiType.FOOD, label: "Kawiarnie i restauracje", icon: PoiFoodIcon, color: POI_COLORS[PoiType.FOOD]}
] as const;

export const getTransportStopPluralizeLabel = (type: TransportPoiType, count: number): string => {
    switch (type) {
        case TransportPoiType.TRAM:
            return `${count} ${pluralize(["przystanek tramwajowy", "przystanki tramwajowe", "przystanków tramwajowych"])(count)}`;
        case TransportPoiType.BUS:
            return `${count} ${pluralize(["przystanek autobusowy", "przystanki autobusowe", "przystanków autobusowych"])(count)}`;
        case TransportPoiType.SUBWAY:
            return `${count} ${pluralize(["przystanek metra", "przystanki metra", "przystanków metra"])(count)}`;
        case TransportPoiType.RAILWAY:
            return `${count} ${pluralize(["stacja kolejowa", "stacje kolejowe", "stacji kolejowych"])(count)}`;
        default:
            return "";
    }
};

export const getNearestStopLabel = (type: TransportPoiType): string => {
    switch (type) {
        case TransportPoiType.RAILWAY:
            return "najbliższa";
        default:
            return "najbliższy";
    }
};
